<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    width="1080px"
    :with-footer="false"
  >
    <TableLayout class="parameter-config-layout" :with-breadcrumb="false" :permissions="['template:parameter:query']">
      <template v-slot:table-wrap>
        <!-- 标签页 -->
        <el-tabs
          :value="currentTab"
          v-loading="isWorking.search"
          addable
          @tab-click="handleTabChange"
          @tab-add="$refs.operaParameterTypeWindow.open('新建参数类型')"
        >
          <el-tab-pane :name="type.variable" v-for="(type, index) in parameterTypes" :key="index.variable">
          <span class="tab-pane-label" slot="label">
            {{type.name}}
            <i class="el-icon-close" @click="deleteTypeById(type)"></i>
            <i class="el-icon-edit" @click="$refs.operaParameterTypeWindow.open('编辑参数类型', type)"></i>
          </span>
            <ul class="toolbar">
              <li><el-button type="primary" @click="$refs.operaParameterWindow.open('新建' + currentType.name, currentType)" icon="el-icon-plus" v-permissions="['template:parameter:create']">新建{{currentType.name}}</el-button></li>
              <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['template:parameter:delete']">删除</el-button></li>
            </ul>
            <!-- 参数列表 -->
            <el-table
              :data="tableData.list"
              stripe
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="code" label="编码" min-width="140px"></el-table-column>
              <el-table-column prop="name" label="名称" min-width="140px"></el-table-column>
              <el-table-column
                v-for="column in columns"
                :key="column.variable"
                :prop="column.variable"
                :label="column.name"
                min-width="100px"
              ></el-table-column>
              <el-table-column prop="remark" label="备注" min-width="200px"></el-table-column>
              <el-table-column prop="createUserInfo.realname" label="创建人" min-width="140px"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
              <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="140px"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
              <el-table-column
                label="操作"
                min-width="120"
                fixed="right"
              >
                <template slot-scope="{row}">
                  <el-button type="text" @click="$refs.operaParameterWindow.open('编辑' + currentType.name, currentType, row)" icon="el-icon-edit" v-permissions="['template:parameter:update']">编辑</el-button>
                  <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['template:parameter:delete']">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
              :pagination="tableData.pagination"
            >
            </pagination>
          </el-tab-pane>
        </el-tabs>
      </template>
      <!-- 新建 & 编辑参数类型 -->
      <OperaParameterTypeWindow ref="operaParameterTypeWindow" :template="template" @success="fetchAllType"/>
      <!-- 新建 & 编辑参数 -->
      <OperaParameterWindow ref="operaParameterWindow" @success="search"/>
    </TableLayout>
  </GlobalWindow>
</template>

<script>
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import Pagination from '@/components/common/Pagination'
import OperaParameterWindow from '@/components/template/parameter/OperaParameterWindow'
import OperaParameterTypeWindow from '@/components/template/parameter/OperaParameterTypeWindow'
import GlobalWindow from '@/components/common/GlobalWindow'
import { fetchAll, deleteById } from '@/api/template/parameterType'
export default {
  name: 'ParameterTableWindow',
  extends: BaseTable,
  components: {
    GlobalWindow,
    OperaParameterWindow,
    Pagination,
    OperaParameterTypeWindow,
    TableLayout
  },
  data () {
    return {
      title: '',
      visible: false,
      template: null,
      currentTabIndex: 0,
      parameterTypes: []
    }
  },
  computed: {
    currentType () {
      return this.parameterTypes[this.currentTabIndex]
    },
    currentTab () {
      return this.currentType == null ? '' : this.currentType.variable
    },
    columns () {
      return JSON.parse(this.currentType.fieldConfig)
    }
  },
  watch: {
    // 切换页签时，记录当前页签位置
    currentTabIndex () {
      this.search()
      window.localStorage.setItem('CURRENT_PARAMETER_TYPE', this.currentType.variable)
    }
  },
  methods: {
    // 打开
    async open (template) {
      this.template = template
      this.title = `配置${template.name}参数`
      this.visible = true
      await this.fetchAllType()
      await this.search()
    },
    // 保存页签的点击位置
    handleTabChange (tab) {
      this.currentTabIndex = tab.index
    },
    // 查询所有类型
    async fetchAllType () {
      await fetchAll(this.template.id)
        .then(data => {
          this.parameterTypes = data
          this.currentTabIndex = this.parameterTypes.findIndex(type => type.variable === window.localStorage.getItem('CURRENT_PARAMETER_TYPE'))
          if (this.currentTabIndex === -1) {
            this.currentTabIndex = 0
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 删除类型
    deleteTypeById (type) {
      this.$dialog.deleteConfirm(`删除后可能影响代码的生成！确认删除参数类型【${type.name}】吗？`)
        .then(() => {
          this.isWorking.delete = true
          deleteById(type.id)
            .then(() => {
              this.fetchAllType()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorking.delete = false
            })
        })
        .catch(() => {})
    },
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      if (this.currentType == null) {
        return
      }
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: {
          typeId: this.currentType.id
        },
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records.map(row => {
            const dynamicFieldConfig = JSON.parse(row.value)
            const dynamicFields = {}
            for (const key in dynamicFieldConfig) {
              dynamicFields[key] = dynamicFieldConfig[key]
            }
            return {
              ...row,
              ...dynamicFields
            }
          })
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    }
  },
  async created () {
    this.config({
      module: '参数配置',
      api: '/template/parameter',
      'field.id': 'id',
      'field.main': 'name'
    })
  }
}
</script>

<style scoped>

</style>
